import { Routes, Route, Navigate } from 'react-router'
import {
  Login,
  ProtectedRoute,
  AuthGuard,
  ForgotPassword,
} from '../components/auth'
import { ROUTES } from './routeConfig'
import {
  Dashboard,
  Returns,
  Provision,
  Admin,
  Download,
  UserManual,
  COF,
  DownloadTemplates,
  PremiumFeature,
  SelfService
} from '../pages';
import { TANForm } from '../components/admin'
import WithholdingTaxPrepare from '../components/Returns/Prepare/Prepare';
import ReturnUpload from '../components/Returns/Upload/ReturnUpload';
import Compute from '../components/Returns/Compute/Compute';
import AddRuleSetting from '../components/Returns/Define/components/AddRuleSetting';
import SSOLogin from "../components/auth/SSOLogin"
import { IT_ADMIN } from '../utils/role-capabilities'
const AppRoutes = () => {
  return (
    <Routes>
      {/* Root route - redirect to login */}
      <Route
        path={ROUTES.ROOT}
        element={<Navigate to={ROUTES.LOGIN} replace />}
      />

      {/* Login route - protected by AuthGuard to prevent access if already logged in */}
      <Route
        path={ROUTES.LOGIN}
        element={
          <AuthGuard>
            <Login />
          </AuthGuard>
        }
      />
      <Route
        path="/:clientId"
        element={
          <AuthGuard>
            <Login />
          </AuthGuard>
        }
      />


      {/* SSO User List - must come before dynamic clientId route */}
      <Route path={ROUTES.LOGIN_USER_LIST} element={<SSOLogin />} />

      {/* Forgot Password */}
      <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />

      {/* Dynamic client route for SSO - must come after specific login routes */}
      <Route
        path="/:clientId"
        element={
          <AuthGuard>
            <Login />
          </AuthGuard>
        }
      />

      {/* SSO User List - must come before dynamic clientId route */}
      <Route path={ROUTES.LOGIN_USER_LIST} element={<SSOLogin />} />

      {/* Forgot Password */}
      <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />

      {/* Dynamic client route for SSO - must come after specific login routes */}
      <Route
        path="/:clientId"
        element={
          <AuthGuard>
            <Login />
          </AuthGuard>
        }
      />

      {/* Protected Dashboard route */}
      <Route
        path={ROUTES.DASHBOARD}
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* Protected Returns route */}
      <Route
        path={ROUTES.RETURNS}
        element={
          <ProtectedRoute>
            <Returns />
          </ProtectedRoute>
        }
      />

      {/* Protected Provision route */}
      <Route
        path={ROUTES.PROVISION}
        element={
          <ProtectedRoute>
            <Provision />
          </ProtectedRoute>
        }
      />

      {/* Protected Admin route */}
      <Route
        path={ROUTES.ADMIN}
        element={
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        }
      />

      {/* Protected Download route */}
      <Route
        path={ROUTES.DOWNLOAD}
        element={
          <ProtectedRoute>
            <Download />
          </ProtectedRoute>
        }
      />

      {/* Protected Add TAN route */}
      <Route
        path={ROUTES.ADMIN_ADD_TAN}
        element={
          <ProtectedRoute>
            <TANForm />
          </ProtectedRoute>
        }
      />

      {/* Protected Edit TAN route */}
      <Route
        path={ROUTES.ADMIN_EDIT_TAN}
        element={
          <ProtectedRoute>
            <TANForm />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.RETURNS_ADD_RULE}
        element={
          <ProtectedRoute>
            <AddRuleSetting />
          </ProtectedRoute>
        }
      />

      {/* Protected Help Center routes */}
      <Route
        path={ROUTES.HELP_USER_MANUAL}
        element={
          <ProtectedRoute>
            <UserManual />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.HELP_COF}
        element={
          <ProtectedRoute>
            <COF />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.HELP_DOWNLOAD_TEMPLATES}
        element={
          <ProtectedRoute>
            <DownloadTemplates />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.RETURNS_PREPARE}
        element={
          <ProtectedRoute>
            <WithholdingTaxPrepare />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.RETURNS_UPLOAD}
        element={
          <ProtectedRoute>
            <ReturnUpload />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.RETURNS_COMPUTE}
        element={
          <ProtectedRoute>
            <Compute />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.PREMIUM_FEATURE}
        element={
          <ProtectedRoute allowedRoles={[IT_ADMIN]}>
            <PremiumFeature />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.SELF_SERVICE}
        element={
          <ProtectedRoute>
            <SelfService />
          </ProtectedRoute>
        }
      />

      {/* Catch all route - redirect to login */}
      {/* <Route path="*" element={<Navigate to={ROUTES.LOGIN} replace />} /> */}
    </Routes>
  )
}

export default AppRoutes
